import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";
import ServiceCard from "./ServiceCard";
import services from "../services";
import SectionTitle from "./SectionTitle";

const Services = () => {
  const { t } = useTranslation();

  const icons = {
    monitoring: "chart",
    consulting: "engineering",
    vpn: "lock",
    routing: "router",
    olt: "sliders",
    incidents: "alert",
  };

  return (
    <section id="services" className="section services-section">
      <div className="page-container">
        <SectionTitle
          eyebrow={t("services_eyebrow")}
          title={t("services_title")}
          subtitle={t("services_subtitle")}
        />
        <div className="services-grid">
          {services.map((service) => (
            <ServiceCard
              key={service.titleKey}
              title={t(service.titleKey)}
              description={t(service.descriptionKey)}
              image={service.image}
              width={service.width}
              height={service.height}
              altText={t(service.altKey)}
              icon={icons[service.icon]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
